import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CsControlsModule } from '@cbuild/controls';
import { DynamicPropertiesComponent } from './dynamic-properties.component';

@NgModule({
  declarations: [DynamicPropertiesComponent],
  imports: [CommonModule, CsControlsModule, ReactiveFormsModule],
  exports: [DynamicPropertiesComponent, CsControlsModule, ReactiveFormsModule]
})
export class DynamicPropertiesModule {}
